import * as React from 'react';
import { SHOW_MAINTENANCE_PAGE } from '../constants';
import { RouterNavLink, RouterNavLinkProps } from './router-nav-link';

export interface NavMenuProps {
  menu: {
    [key: string]: RouterNavLinkProps;
  };
  activeClassName?: string;
  menuClassName?: string;
  itemClassName?: string;
  children?: void;
}

export function NavMenu(props: NavMenuProps): React.ReactElement<NavMenuProps> {
  const menuClassName = [props.menuClassName, 'nav'].join(' ');
  const itemClassName = [props.itemClassName, 'nav-item'].join(' ');

  return (
    <ul className={menuClassName}>
      {Object.keys(props.menu).map((key) => {
        const navLinkProps = props.menu[key];
        navLinkProps.className = SHOW_MAINTENANCE_PAGE() ? [navLinkProps.className, 'maintenance-nav-link'].join(' ') : [navLinkProps.className, 'nav-link'].join(' ');
        navLinkProps.activeClassName = props.activeClassName || '';

        return (
          <li key={key} className={itemClassName}>
            <RouterNavLink {...navLinkProps} />
          </li>
        );
      })}
    </ul>
  );
}
